export const DEBOUNCE_DELAY = 200
export const MIN_SEARCH_LENGTH = 3
export const MAX_OPTIONS = 3
